export default __webpack_public_path__ + "static/media/CU.44b0cdce.ico";